import '../Styles/Features.css';
import '../Styles/Home.css';
import '../Styles/App.css';

import React from 'react';
import { motion } from 'framer-motion';
import VoidStats from '../components/VoidStats';
import Features from '../components/Features';

const apps = [
    {
        name: 'CYPHR VOID',
        description: 'CYPHR VOID is your secure and private platform to express yourself. Share your thoughts, creative ideas, and updates in a community where your privacy is our priority.',
        link: 'https://apps.apple.com/us/app/cyphr-void/id6744314582',
        icon: '/icons/void-icon.png',
    },
    {
        name: 'CYPHR VOID WEB',
        description: 'CYPHR VOID WEB is your same secure and private platform for the Web. Void Unlimited users can gain full access while free users can view the Void.',
        link: 'https://cyphr-systems-void.web.app',
        icon: '/icons/void-unlimited-icon.png',
    }
];

function CyphrVoid() {
    return (
        <>

            <div className="apps-section">
                {apps.map((app) => (
                    <motion.div
                        key={app.name}
                        className="app-card"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.3 }}
                    >
                        <img src={app.icon} alt={`${app.name} Icon`} className="app-icon" />
                        <h2>{app.name}</h2>
                        <p>{app.description}</p>
                        <a href={app.link} target="_blank" rel="noopener noreferrer">
                            Learn More
                        </a>
                    </motion.div>
                ))}
            </div>
            <div className="home">
                <Features />
            </div>
            <VoidStats />
        </>
    );
}

export default CyphrVoid;
